import { render, staticRenderFns } from "./QuotationSelectedCompany.vue?vue&type=template&id=779945d4"
import script from "./QuotationSelectedCompany.vue?vue&type=script&lang=js"
export * from "./QuotationSelectedCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports